import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 	from	'moment';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdSeriesPreAnnouncement from './_CrowdSeriesPreAnnouncement.jsx';
import CrowdSeriesUpcoming from './_CrowdSeriesUpcoming.jsx';
import CrowdSeriesIntake from './_CrowdSeriesIntake.jsx';
import CrowdSeriesValidation from './_CrowdSeriesValidation.jsx';
import CrowdSeriesPostValidation from './_CrowdSeriesPostValidation.jsx';
import CrowdSeriesFinalists from './_CrowdSeriesFinalists.jsx';
import CrowdSeriesPreCrowd from './_CrowdSeriesPreCrowd.jsx';
import CrowdSeriesCrowdfunding from './_CrowdSeriesCrowdfunding.jsx';
import CrowdSeriesShipped from './_CrowdSeriesShipped.jsx';
import blAjax from '../../utils/_ajax.jsx';

export default class CrowdSeriesContainer extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.series = blapp.models.get('listSeries') || null;
		this.seriesNumber = parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.finalists = blapp.models.get('submissions_finalists') || [];

		const aoc = blapp.util.getUrlVars().aoc;
		if ( (typeof aoc !== "undefined") && (aoc.trim() !== "") )
		{
			this.trackAdCode(aoc);
		}
	}

	render() {
  	const selectedSeries = this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];

  	if(selectedSeries) {
			const preCrowdfundingSeries = blapp.config.server_time >= selectedSeries.udtCrowdFundingAnnouncement && blapp.config.server_time <= selectedSeries.udtCrowdFundingStart;
			const crowdfundingSeries = blapp.config.server_time >= selectedSeries.udtCrowdFundingStart && blapp.config.server_time <= selectedSeries.udtCrowdFundingEnd;
			const isShipped = blapp.config.server_time >= moment(selectedSeries.udtProductionStart).subtract(7, 'days');

			if(isShipped) {
				// console.log('shipped');

				return <CrowdSeriesShipped/>
			}else if(crowdfundingSeries || blapp.config.server_time >= selectedSeries.udtCrowdFundingEnd) {
				// console.log('crowdfunding');

  			return <CrowdSeriesCrowdfunding/>;
			}else if(preCrowdfundingSeries) {
  			// console.log('pre-crowd')
  			return <CrowdSeriesPreCrowd/>;
			}else if(selectedSeries.phase == 'VALIDATION') {
  			// console.log('val')
  			return <CrowdSeriesValidation/>;
  		}else if((selectedSeries.phase == 'POST_VALIDATION' || selectedSeries.phase == 'WAITING') && !this.finalists.data.submissions.length) {
  			// console.log('post-val')
  			return <CrowdSeriesPostValidation/>;
  		}else if(selectedSeries.phase == 'POST_VALIDATION' && this.finalists.data.submissions.length) {
  			console.log('past - finalists')
  			return <CrowdSeriesFinalists/>;
			}else if(selectedSeries.phase == 'FUNDING') {
				// console.log('past - finalists')
				return <CrowdSeriesFinalists/>;
  		}else if(selectedSeries.phase == 'INTAKE') {
  			// console.log('intake');
  			return <CrowdSeriesIntake/>;
  		}else if(blapp.config.server_time < selectedSeries.udtPaletteAdded){
  			// console.log('pre announcemet');
  			return <CrowdSeriesPreAnnouncement/>;
  		}else{
  			// console.log('upcoming');
  			return <CrowdSeriesUpcoming/>;
  		}
  	}else{
  		return (
  			<div className="main">
					<div className="main__content">
						<div className="bdp-my-upload-block bdp-my-upload-block--closed" data-ts-name="bdp-my-upload-block--closed">
							<h2 className="l-margin-bottom--xl">No access.</h2>
						</div>
					</div>
				</div>
			)
  	}
	}

	trackAdCode(aoc) 
	{
		blAjax.call(
			"/track_ad.ajax"
		,	{
				aoc:	aoc,
				pageId: blapp.track.getPageID()
			}
		);
	}
}

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<CrowdSeriesContainer blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-crowd' )
						);
		blapp.refs.register( "main", elem );
	}
);